import { isRent } from "@Utils/Functions"
import { Typography } from "antd"

type GuaranteeProps = { guarantee:string, opTypeID: number | string }

export const Guarantee = ({guarantee, opTypeID}:GuaranteeProps) => {
    
    if(!isRent(opTypeID) || !guarantee) return null

    return <div>
        <Typography.Title level={4}>{ "Garantías" }</Typography.Title>
        <Typography.Paragraph>{guarantee}</Typography.Paragraph>
    </div>
}
